import { ESTADOS_PRODUCTO, IProducto } from '../interface/IProducto';
import { ICodigoProducto } from '../interface/ICodigoProducto';
import {Categoria} from './Categoria';

export class Producto implements IProducto {

  id?: number;
  nombre?: string;
  nombreCorto?: string;
  imagen?: string;
  descipcion?: string;
  detalle?: string;
  especificaciones?: any;
  estado?: ESTADOS_PRODUCTO;
  esPublicado: boolean;
  seleccionSF?: number;
  subEstado?: string;
  orden?: number;
  ordenEn?: number;
  marcaId?: number;
  marca?: any;
  codigos?: ICodigoProducto[];
  codigoProductoId?: number;
  fecCreacion?: Date;
  creadoPor?: string;
  fecModificacion?: Date;
  modificadoPor?: string;
  arbolCategorias?: Categoria[];
  totalProductosRelacionados?: number;
  totalProductosComplementarios?: number;
  totalProductosAlternativos?: number;
  totalCodigos?: number;
  totalFotosVideos?: number;
  selected: boolean;

  constructor(producto: IProducto) {
    this.id = producto.id;
    this.nombre = producto.nombre;
    this.nombreCorto = producto.nombreCorto;
    this.imagen = producto.imagen;
    this.descipcion = producto.descipcion;
    this.detalle = producto.detalle;
    this.especificaciones = producto.especificaciones;
    this.estado = producto.estado;
    this.esPublicado = producto.esPublicado;
    this.seleccionSF = producto.seleccionSF;
    this.subEstado = producto.subEstado;
    this.orden = producto.orden;
    this.ordenEn = producto.ordenEn;
    this.marcaId = producto.marcaId;
    this.marca = producto.marca;
    this.codigos = producto.codigos;
    this.codigoProductoId = producto.codigoProductoId;
    this.fecCreacion = producto.fecCreacion;
    this.creadoPor = producto.creadoPor;
    this.fecModificacion = producto.fecModificacion;
    this.modificadoPor = producto.modificadoPor;
    this.arbolCategorias = producto.arbolCategorias;
    this.totalProductosRelacionados = producto.totalProductosRelacionados;
    this.totalProductosComplementarios = producto.totalProductosComplementarios;
    this.totalProductosAlternativos = producto.totalProductosAlternativos;
    this.totalCodigos = producto.totalCodigos;
    this.totalFotosVideos = producto.totalFotosVideos;
  }

  setEspecificaciones(data: {caracteristica: string, valor: string, otro?: string}[], esVertical: boolean) {
    const caracteristicas = [];

    if (data[0] && (data[0].caracteristica || data[0].valor)) {
      for (const o of data) {
        if (o.caracteristica || o.valor) {
          caracteristicas.push(o);
        }
      }
    }
    this.especificaciones = {
      esVertical: esVertical,
      caracteristicas: caracteristicas
    };
  }

  getFormDataSeleccionSF(): FormData {
    const formData = new FormData();
    if (typeof this.orden !== 'undefined') {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }

    if (typeof this.seleccionSF !== 'undefined') {
      formData.append('seleccionSF', String(Number(this.seleccionSF)));
    } else {
      formData.append('seleccionSF', '0');
    }

    return formData;
  }

  getFormData(): FormData {
    const formData = new FormData();

    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.descipcion) {
      formData.append('descipcion', this.descipcion);
    }
    if (this.detalle) {
      formData.append('detalle', this.detalle);
    }
    if (this.especificaciones) {
      formData.append('especificaciones', JSON.stringify(this.especificaciones));
    }
    if (this.marcaId || this.marcaId === 0) {
      formData.append('marcaId', String(this.marcaId));
    }
    if (this.estado) {
      formData.append('estado', this.estado);
    }
    if (this.esPublicado) {
      formData.append('esPublicado', 'PUBLICADO');
    } else {
      formData.append('esPublicado', 'NO_PUBLICADO');
    }

    if (this.orden) {
      formData.append('orden', String(this.orden));
    } else {
      formData.append('orden', '0');
    }

    if (this.seleccionSF) {
      formData.append('seleccionSF', String(Number(this.seleccionSF)));
    } else {
      formData.append('seleccionSF', '0');
    }

    return formData;
  }
}



// WEBPACK FOOTER //
// /app/src/model/class/Producto.ts